import { render, staticRenderFns } from "./navigation.component.vue?vue&type=template&id=24ba622a&scoped=true&"
import script from "./navigation.component.vue?vue&type=script&lang=ts&"
export * from "./navigation.component.vue?vue&type=script&lang=ts&"
import style0 from "./navigation.component.vue?vue&type=style&index=0&id=24ba622a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba622a",
  null
  
)

export default component.exports